module.exports = __webpack_public_path__ + "static/img/number-copy.4a8c4e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article_3/portrait/number-copy.png
// module id = 2HOc
// module chunks = 1